// import React, { useState } from "react";
// import { setSessionStorage } from "Helper";
// import axios from "axios";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faExclamationTriangle, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
// import { ClipLoader } from "react-spinners";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// import { API_BASE_URL } from "Config";
// import PropTypes from "prop-types";
// const MySwal = withReactContent(Swal);

// const Login = ({ onLogin }) => {
//   const [companyID, setCompanyID] = useState("");
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [check, setCheck] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     setLoading(true);
//     try {
//       const obj = {
//         cid: companyID,
//         username: username,
//         userpassword: password,
//       };
//       const response = await axios.post(`${API_BASE_URL}/auth/login`, obj);
//       //   null,
//       //   {
//       //     params: obj,
//       //   }
//       // );

//       if (response.status === 200) {
//         if (response.data.statusText === "success") {
//           setSessionStorage("custName", response.data.data.fullname);
//           setSessionStorage("custType", response.data.data.usertype);
//           setSessionStorage("cid", companyID);
//           setSessionStorage("accode", username);
//           setSessionStorage("isLoggedIn", "true");
//           setSessionStorage("emailid", response.data.data.emailid);
//           onLogin(true);
//           if (rememberMe) {
//             localStorage.setItem("custName", response.data[0].FullName);
//             localStorage.setItem("custType", response.data[0].UserType);
//             localStorage.setItem("cid", companyID);
//             localStorage.setItem("accode", username);
//             localStorage.setItem("isLoggedIn", "true");
//           }

//           MySwal.fire({
//             title: "Login Successful!",
//             text: "You will be redirected shortly.",
//             icon: "success",
//             timer: 2000,
//             showConfirmButton: false,
//           }).then(() => {
//             navigate("/Customer/dashboard"); // Replace with the route you want to redirect to
//           });
//         } else {
//           MySwal.fire({
//             title: "Login Unsuccessful",
//             text: "Invalid Credentials",
//             icon: "error",
//             showConfirmButton: true,
//           });
//         }
//       } else if (response.status === 401) {
//         MySwal.fire({
//           title: "Error 401",
//           text: "Unauthorized",
//           icon: "error",
//           showConfirmButton: true,
//         });
//       } else if (response.status === 500) {
//         MySwal.fire({
//           title: "Internal Server Error",
//           text: "Please try again later.",
//           icon: "error",
//           showConfirmButton: true,
//         });
//       }
//     } catch (error) {
//       if (error.response) {
//         MySwal.fire({
//           title: "Error",
//           text: error.response.data.error,
//           icon: "error",
//           showConfirmButton: true,
//         });
//       } else {
//         MySwal.fire({
//           title: "Network Error",
//           text: "Please try again.",
//           icon: "error",
//           showConfirmButton: true,
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleKeyPress = (event) => {
//     setCheck(true);
//     if (event.key === "Enter" && username && password && companyID) {
//       handleLogin();
//     }
//   };

//   return (
//     <div className="h-screen w-screen flex items-center justify-center relative">
//       <div
//         className="absolute inset-0 bg-cover bg-center"
//         style={{
//           backgroundImage: `url(/Customer/loginBanner.png)`,
//           filter: "blur(3px)",
//         }}
//       ></div>
//       <div className="relative z-10 w-full flex items-center justify-center">
//         <div
//           className="relative bg-white bg-opacity-10 shadow-md flex flex-col m-5 h-auto md:h-3/4 w-11/12 md:w-1/3 rounded-md p-8"
//           style={{
//             backgroundColor: "rgba(255, 255, 255, 0.1)",
//             color: "white",
//             padding: "20px",
//             borderRadius: "8px",
//           }}
//         >
//           <div className="w-full flex flex-col justify-center p-4">
//             <p className="text-2xl font-semibold text-center text-white">
//               Login to <span className="text-blue-600 fw-bold">Magix</span>
//             </p>
//             <p className="text-sm text-gray-200 mt-2 font-semibold text-center">
//               Welcome to Magix Customer Portal.
//             </p>
//             <div className="mt-4">
//               <div className="flex items-center">
//                 <label htmlFor="CompanyID" className="block text-md font-medium text-blue-600">
//                   Company ID:
//                 </label>
//                 {check && !companyID && (
//                   <FontAwesomeIcon icon={faExclamationTriangle} className="fa ml-4 text-red-600" />
//                 )}
//               </div>
//               <input
//                 type="text"
//                 required
//                 id="companyID"
//                 placeholder="Enter Company ID"
//                 className="mt-1 w-full shadow-sm px-2 py-1 border border-gray-300 rounded-md text-black"
//                 value={companyID}
//                 onChange={(e) => setCompanyID(e.target.value.toUpperCase())}
//               />
//             </div>
//             <div className="mt-2">
//               <div className="flex items-center">
//                 <label htmlFor="username" className="block text-md font-medium text-blue-600">
//                   Username:
//                 </label>
//                 {check && !username && (
//                   <FontAwesomeIcon icon={faExclamationTriangle} className="fa ml-4 text-red-600" />
//                 )}
//               </div>
//               <input
//                 type="text"
//                 required
//                 id="username"
//                 placeholder="Enter Username"
//                 className="mt-1 w-full shadow-sm px-2 py-1 border border-gray-300 rounded-md text-black"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//               />
//             </div>
//             <div className="mt-2 relative">
//               <div className="flex items-center">
//                 <label htmlFor="password" className="block text-md font-medium text-blue-600">
//                   Password:
//                 </label>
//                 {check && !password && (
//                   <FontAwesomeIcon icon={faExclamationTriangle} className="fa ml-4 text-red-600" />
//                 )}
//               </div>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 required
//                 id="password"
//                 placeholder="Enter Password"
//                 className="mt-1 w-full shadow-sm px-2 py-1 border border-gray-300 rounded-md text-black"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 onKeyDown={handleKeyPress}
//               />
//               <FontAwesomeIcon
//                 icon={showPassword ? faEye : faEyeSlash}
//                 className="absolute text-blue-600 mt-3 me-2  top-1/2 right-2 transform -translate-y-1/2 cursor-pointer"
//                 onClick={() => setShowPassword(!showPassword)}
//               />
//             </div>
//             <div className="mt-2 flex items-center">
//               <input
//                 type="checkbox"
//                 id="rememberMe"
//                 className="mr-2"
//                 checked={rememberMe}
//                 onChange={(e) => setRememberMe(e.target.checked)}
//               />
//               <label htmlFor="rememberMe" className="text-sm text-gray-200">
//                 Remember Me
//               </label>
//             </div>
//             <button
//               type="submit"
//               onClick={handleLogin}
//               disabled={!username || !password || !companyID || loading}
//               className="cursor-pointer px-6 py-1 w-full text-white rounded-md mt-6 font-bold text-md border bg-blue-600 hover:bg-blue-700 flex items-center justify-center transition duration-300 ease-in-out transform hover:scale-105"
//             >
//               {loading ? <ClipLoader color={"#fff"} size={24} /> : "Login"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// Login.propTypes = {
//   onLogin: PropTypes.func.isRequired,
// };

// export default Login;

import React, { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";

// MUI Components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// import bgImage from "loginBanner.png";
import { setSessionStorage } from "../../../Helper";
import { API_BASE_URL } from "Config";

const MySwal = withReactContent(Swal);

const Login = ({ onLogin }) => {
  const [companyID, setCompanyID] = useState("MAXPACIFIC");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [check, setCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (isLoggedIn) => {
    setLoading(true);
    try {
      const obj = {
        cid: companyID,
        username: username,
        userpassword: password,
      };

      const response = await axios.post(`${API_BASE_URL}/auth/login`, obj);

      if (response.data.status === 200 && response.data.data) {
        const userData = response.data.data;

        setSessionStorage("custName", userData.fullname);
        setSessionStorage("custType", userData.usertype);
        setSessionStorage("cid", companyID);
        setSessionStorage("accode", username);
        setSessionStorage("isLoggedIn", "true");
        setSessionStorage("emailid", userData.emailid);
        onLogin(true);

        if (rememberMe) {
          localStorage.setItem("custName", userData.fullname);
          localStorage.setItem("custType", userData.usertype);
          localStorage.setItem("cid", companyID);
          localStorage.setItem("accode", username);
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem("emailid", userData.emailid);
        }

        MySwal.fire({
          title: "Login Successful!",
          text: "You will be redirected shortly.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          navigate("/dashboard", { replace: true });
        });
      } else {
        MySwal.fire({
          title: "Login Unsuccessful",
          text: "Invalid Credentials",
          icon: "error",
          showConfirmButton: true,
        });
      }
    } catch (error) {
      MySwal.fire({
        title: error.response ? "Error" : "Network Error",
        text: error.response ? error.response.data.error : "Please try again.",
        icon: "error",
        showConfirmButton: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    setCheck(true);
    if (event.key === "Enter" && username && password && companyID) {
      handleLogin();
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${process.env.PUBLIC_URL}/loginBanner.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Card
        sx={{
          width: { xs: "90%", md: "400px" },
          p: 4,
          borderRadius: 3,
          bgcolor: "rgba(255,255,255,0.15)",
          backdropFilter: "blur(12px)",
          color: "white",
        }}
      >
        <Typography variant="h5" textAlign="center" fontWeight={600} gutterBottom>
          <span style={{ color: "#2196f3" }}>Login To Magix</span>
        </Typography>
        <Typography variant="body2" textAlign="center" mb={2} sx={{ color: "#e0e0e0" }}>
          Welcome to Magix Customer Portal.
        </Typography>

        {/* <TextField
          fullWidth
          label="Company ID"
          variant="standard"
          margin="normal"
          InputLabelProps={{ style: { color: "#ffffff" } }}
          InputProps={{ style: { color: "#ffffff" } }}
          value={companyID}
          onChange={(e) => setCompanyID(e.target.value.toUpperCase())}
          error={check && !companyID}
          helperText={check && !companyID && "Company ID is required"}
        /> */}

        <TextField
          fullWidth
          label="Username"
          variant="standard"
          margin="normal"
          InputLabelProps={{ style: { color: "#ffffff" } }}
          InputProps={{ style: { color: "#ffffff" } }}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          error={check && !username}
          helperText={check && !username && "Username is required"}
        />

        <Box position="relative">
          <TextField
            fullWidth
            type={showPassword ? "text" : "password"}
            label="Password"
            variant="standard"
            margin="normal"
            InputLabelProps={{ style: { color: "#ffffff" } }}
            InputProps={{ style: { color: "#ffffff" } }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyPress}
            error={check && !password}
            helperText={check && !password && "Password is required"}
          />
          <FontAwesomeIcon
            icon={showPassword ? faEyeSlash : faEye}
            style={{
              position: "absolute",
              top: "50%",
              right: 10,
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#fff",
            }}
            onClick={() => setShowPassword(!showPassword)}
          />
        </Box>

        <Box display="flex" alignItems="center" mt={2}>
          <Checkbox
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            sx={{ color: "white" }}
          />
          <Typography variant="body2" sx={{ color: "#e0e0e0" }}>
            Remember Me
          </Typography>
        </Box>

        <Button
          fullWidth
          variant="contained"
          sx={{
            mt: 3,
            mb: 2,
            py: 1.5,
            fontWeight: 600,
            backgroundColor: "#1976d2",
            color: "white !important", // Force white text
            textTransform: "none", // Prevent uppercase transformation
            fontSize: "1rem",
            "&:hover": {
              backgroundColor: "#1565c0",
              color: "white !important",
            },
            "&:disabled": {
              backgroundColor: "#64b5f6",
              color: "white !important",
              opacity: 0.8,
            },
          }}
          onClick={handleLogin}
          disabled={!username || !password || !companyID || loading}
        >
          {loading ? "Logging in...." : "Login"}
        </Button>
      </Card>
    </Box>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default Login;
